import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const ADMIN_KEY = "namya-admin-token";

export const getAdminToken = () => sessionStorage.getItem(ADMIN_KEY) || "";
export const setAdminToken = (t) => sessionStorage.setItem(ADMIN_KEY, t);
export const clearAdminToken = () => sessionStorage.removeItem(ADMIN_KEY);

const adminHeaders = () => ({ "X-Admin-Token": getAdminToken() });

export { adminHeaders };

// ---- Public ----
export const fetchDiseases = () => axios.get(`${API}/diseases`).then((r) => r.data);

// Unified blogs (optional category filter).
export const fetchBlogs = (category) => {
  const params = category ? { category } : {};
  return axios.get(`${API}/blogs`, { params }).then((r) => r.data);
};
export const fetchBlog = (id) => axios.get(`${API}/blogs/${id}`).then((r) => r.data);

// Unified videos (optional category filter).
export const fetchVideos = (category) => {
  const params = category ? { category } : {};
  return axios.get(`${API}/videos`, { params }).then((r) => r.data);
};

export const fetchMedications = () =>
  axios.get(`${API}/medications`).then((r) => r.data);
export const fetchMedication = (id) =>
  axios.get(`${API}/medications/${id}`).then((r) => r.data);

// ---- Admin ----
export const verifyAdmin = (token) =>
  axios.post(`${API}/admin/verify`, { token });

export const fetchAppointments = () =>
  axios.get(`${API}/appointments`, { headers: adminHeaders() }).then((r) => r.data);

// Disease CRUD
export const createDisease = (data) =>
  axios.post(`${API}/diseases`, data, { headers: adminHeaders() }).then((r) => r.data);
export const updateDisease = (id, data) =>
  axios.put(`${API}/diseases/${id}`, data, { headers: adminHeaders() }).then((r) => r.data);
export const deleteDisease = (id) =>
  axios.delete(`${API}/diseases/${id}`, { headers: adminHeaders() }).then((r) => r.data);

// Blog CRUD
export const createBlog = (data) =>
  axios.post(`${API}/blogs`, data, { headers: adminHeaders() }).then((r) => r.data);
export const updateBlog = (id, data) =>
  axios.put(`${API}/blogs/${id}`, data, { headers: adminHeaders() }).then((r) => r.data);
export const deleteBlog = (id) =>
  axios.delete(`${API}/blogs/${id}`, { headers: adminHeaders() }).then((r) => r.data);

// Video CRUD
export const createVideo = (data) =>
  axios.post(`${API}/videos`, data, { headers: adminHeaders() }).then((r) => r.data);
export const updateVideo = (id, data) =>
  axios.put(`${API}/videos/${id}`, data, { headers: adminHeaders() }).then((r) => r.data);
export const deleteVideo = (id) =>
  axios.delete(`${API}/videos/${id}`, { headers: adminHeaders() }).then((r) => r.data);

// Medication CRUD
export const createMedication = (data) =>
  axios.post(`${API}/medications`, data, { headers: adminHeaders() }).then((r) => r.data);
export const updateMedication = (id, data) =>
  axios.put(`${API}/medications/${id}`, data, { headers: adminHeaders() }).then((r) => r.data);
export const deleteMedication = (id) =>
  axios.delete(`${API}/medications/${id}`, { headers: adminHeaders() }).then((r) => r.data);
